import {MyNewsTabType} from '../../../graphql/generated/types';

export function selectTabStateKeyByTabType(tab?: MyNewsTabType) {
  if (tab === MyNewsTabType.My) {
    return 'my';
  } else if (tab === MyNewsTabType.Up) {
    return 'up';
  } else {
    return 'all';
  }
}
